import { atomWithStorage } from 'jotai/utils';

export const practiceDataAtom = atomWithStorage<{
	accentColor?: string;
	practiceName?: string;
	practiceLogo?: string;
	clientIdentity?: string;
	requireDueForms?: boolean;
} | null>('CHECK_IN_PRACTICE_STATE', {
	accentColor: '#001E66',
	requireDueForms: false,
});
